import { jsx as _jsx } from "react/jsx-runtime";
import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
const container = document.getElementById("root");
if (container) {
    ReactDOM.createRoot(container).render(_jsx(React.StrictMode, { children: _jsx(App, {}) }));
}
